import CheckListBasicForm from './components/CheckListBasicForm'
import CheckListTable from './components/CheckListTable'
import useGetCheckList from './hooks/useGetCheckList'
import useAddCheckSheet from './hooks/useAddCheckSheet'
import AuthComponent from '../../components/AuthComponent'
import { useState, useEffect } from 'react'
import { PlusOutlined, DownloadOutlined } from '@ant-design/icons'
import { Card, Button, Space, message } from 'antd'
import * as Utils from '../../@utils'
import service from '../../@services'
const checkBillBaseKey = '/inventory/check-sheet/'
export default function Check(props) {
  const checkNo = props.location.query?.checkNo
  const { pageData, getList, loading } = useGetCheckList()
  const [showAdd, setShowAdd] = useState(false)
  const [storeCode, setStoreCode] = useState(null)
  const [selectedItems, setSelectedItems] = useState([])
  const { showAddCheckSheet } = useAddCheckSheet(setShowAdd, getList, storeCode)
  const confirmQueryByFormData = async res => {
    if (res && res.formData) {
      setStoreCode(res.formData.storeCode)
    }
    await getList(res)
    setSelectedItems([])
  }
  const exportData = async () => {
    if (selectedItems.length > 0) {
      let res = await service.inventory.checkSheetExport(selectedItems)
      let fileName =
        '盘点单据' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
      Utils.download(res, fileName)
    } else {
      message.info('请选择单据')
    }
  }
  const btns = (
    <Space>
      <AuthComponent authKey={checkBillBaseKey + 'create'}>
        <Button
          icon={<PlusOutlined />}
          onClick={() => showAddCheckSheet()}
          type='primary'>
          新增盘点单
        </Button>
      </AuthComponent>
      <AuthComponent authKey={checkBillBaseKey + 'export'}>
        <Button type='primary' icon={<DownloadOutlined />} onClick={exportData}>
          导出
        </Button>
      </AuthComponent>
    </Space>
  )
  return (
    <>
      <div style={showAdd ? { width: 0, height: 0, overflow: 'hidden' } : {}}>
        <CheckListBasicForm
          checkNo={checkNo}
          getList={confirmQueryByFormData}></CheckListBasicForm>
        <Card style={{ marginTop: 20 }}>
          <div style={{ marginBottom: 20 }}>{btns}</div>
          <CheckListTable
            pageData={pageData}
            storeCode={storeCode}
            rowSelection={{
              onChange: setSelectedItems,
              selectedRowKeys: selectedItems
            }}
            setShowAdd={setShowAdd}
            getList={getList}
            loading={loading}
          />
        </Card>
      </div>
      <div id='add-check-sheet-container'></div>
    </>
  )
}
